<div class="auth-modal-container">
  <div class="modal-header auth-header">
    <div class="auth-logo">
      <img height="30" width="auto" [src]="logoImage()" alt="logo" />
    </div>
    <button
      (click)="source() === 'kyc-verification' ? closeModal() : closeModalWithData()"
      type="button"
      class="close-button default-button"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M6.71057 3.63708L12.9242 9.81308L19.1057 3.66908C19.2422 3.52463 19.4067 3.40907 19.5893 3.32934C19.7718 3.24961 19.9687 3.20734 20.1681 3.20508C20.5951 3.20508 21.0045 3.37365 21.3064 3.67371C21.6083 3.97377 21.7779 4.38073 21.7779 4.80508C21.7816 5.00124 21.745 5.1961 21.6703 5.37769C21.5955 5.55928 21.4842 5.72377 21.3432 5.86108L15.0813 12.0051L21.3432 18.2291C21.6086 18.4871 21.7641 18.8364 21.7779 19.2051C21.7779 19.6294 21.6083 20.0364 21.3064 20.3364C21.0045 20.6365 20.5951 20.8051 20.1681 20.8051C19.963 20.8135 19.7583 20.7795 19.5671 20.7051C19.3759 20.6308 19.2023 20.5177 19.0574 20.3731L12.9242 14.1971L6.72667 20.3571C6.59065 20.4967 6.42816 20.6082 6.24858 20.6851C6.06899 20.762 5.87586 20.8028 5.68033 20.8051C5.2534 20.8051 4.84395 20.6365 4.54206 20.3364C4.24017 20.0364 4.07057 19.6294 4.07057 19.2051C4.06682 19.0089 4.10344 18.8141 4.17818 18.6325C4.25292 18.4509 4.36421 18.2864 4.50521 18.1491L10.7672 12.0051L4.50521 5.78108C4.2399 5.52309 4.08432 5.17374 4.07057 4.80508C4.07057 4.38073 4.24017 3.97377 4.54206 3.67371C4.84395 3.37365 5.2534 3.20508 5.68033 3.20508C6.06667 3.20988 6.43691 3.36508 6.71057 3.63708Z"
          fill="black"
        />
      </svg>
    </button>
  </div>
  <!-- State-based component rendering -->
  @switch (selectedState()) {
    @case (AuthState.SIGN_UP) {
      <app-sign-up
        [autoRedirectOnSocialLogin]="autoRedirectOnSocialLogin()"
        [postAuthRedirect]="postAuthRedirect()"
        (changeToSignInPage)="changeState(AuthState.SIGN_IN)"
        (signUpRequestCreated)="
          signupRequestInfo.set($event); changeState(AuthState.VERIFY_ACCOUNT)
        "
      />
    }
    @case (AuthState.SIGN_IN) {
      <app-sign-in
        (signedIn)="closeModalWithData()"
        (goToForgotPassword)="changeState(AuthState.FORGOT_PASSWORD)"
        (goToSignUp)="changeState(AuthState.SIGN_UP)"
        [autoRedirectOnSocialLogin]="autoRedirectOnSocialLogin()"
        [postAuthRedirect]="postAuthRedirect()"
      />
    }
    @case (AuthState.FORGOT_PASSWORD) {
      <app-forgot-password
        (forgotPasswordRequested)="
          signupRequestInfo.set({ email: $event.email, signupRequestId: '' });
          changeState(AuthState.OTP_VERIFICATION)
        "
        (goToSignIn)="changeState(AuthState.SIGN_IN)"
      />
    }
    @case (AuthState.VERIFY_ACCOUNT) {
      <app-verify-account
        [resendOtpAction]="regenerateSignUpOTP()"
        [submitOtpAction]="this.submitSignUpOtp()"
        [successMessage]="successMessage()"
        [defaultErrorMessage]="''"
        [validationErrorMessage]="validationErrorMessage()"
        [signupRequestInfo]="signupRequestInfo()"
        (otpSubmitted)="closeModalWithData()"
      />
    }
    @case (AuthState.RESET_PASSWORD) {
      <app-reset-password
        [email]="resetPasswordOtp().email"
        [otp]="resetPasswordOtp().otp"
        (passwordChanged)="changeState(AuthState.RESET_SUCCESS)"
      />
    }
    @case (AuthState.RESET_SUCCESS) {
      <app-reset-success (goToSignIn)="changeState(AuthState.SIGN_IN)" />
    }
    @case (AuthState.OTP_VERIFICATION) {
      <app-verify-account
        [signupRequestInfo]="signupRequestInfo()"
        [successMessage]="successMessage()"
        [defaultErrorMessage]="''"
        [submitOtpAction]="verifyResetPasswordOtp()"
        [resendOtpAction]="resendResetPasswordOtp()"
        [validationErrorMessage]="validationErrorMessage()"
        (otpSubmitted)="resetPasswordOtp.set($event); changeState(AuthState.RESET_PASSWORD)"
      />
    }
    @case (AuthState.SIGNUP_SUCCESS) {
      <!-- Needs to be thought why was this there -->
    }
    @case (AuthState.REFERRAL_CODE) {
      <app-referral-code (skipReferralHandling)="closeModalWithData()" />
    }
  }
</div>
